import React from 'react';
import cardLogo from '../../../assets/cardLogo.png';

function Card({ card, isFlipped, isAutoFlipping, isGlowing, canClick, onClick, isMatched }) {

  const handleClick = () => {
    if (canClick) {
      onClick();
    }
  };

  // Determine the image URL once
  const imageUrl = card.image
    ? (card.image.imageUrl || card.image.url || card.image.downloadURL || card.image.src)
    : null;

  return (
    <>
      <div className="card-container" onClick={handleClick} style={{ cursor: canClick ? 'pointer' : 'default', touchAction: 'manipulation' }}>
        <div
          className={`memory-card ${isFlipped ? 'flipped' : ''} ${card.isMatched ? 'matched' : ''} ${isGlowing ? 'glowing' : ''}`}
        >
          {/* Back face - card logo */}
          <div className="card-face card-face-back">
            <img
              src={cardLogo}
              alt="Card Back"
              className="card-back-logo"
            />
          </div>

          {/* Front face - image or text */}
          <div className="card-face card-face-front">
            {imageUrl ? (
              <div className="card-content">
                <img
                  src={imageUrl}
                  alt={card.word}
                  className="card-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="card-text-fallback" style={{ display: 'none' }}>
                  {card.word}
                </div>
              </div>
            ) : (
              <div className="card-text">{card.word}</div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .card-container {
          perspective: 1000px;
          -webkit-perspective: 1000px;
          width: 100%;
          height: 100%;
          touch-action: manipulation;
          overflow: hidden;
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
        }

        .memory-card {
          min-height: 120px;
          height: 100%;
          width: 100%;
          position: relative;
          transform-style: preserve-3d;
          -webkit-transform-style: preserve-3d;
          transition: transform 0.5s ease;
          -webkit-transition: -webkit-transform 0.5s ease;
        }

        .memory-card.flipped {
          transform: rotateY(180deg);
          -webkit-transform: rotateY(180deg);
        }

        .card-face {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
        }

        .card-face-back {
          /* Back face is default (0deg) */
          z-index: 2;
        }

        .card-face-front {
          /* Front face is rotated 180deg so it shows when card flips */
          transform: rotateY(180deg);
          z-index: 1;
        }

        @keyframes cardGlow {
          0% {
            box-shadow: 0 0 5px rgba(255, 215, 0, 0.7);
          }
          50% {
            box-shadow: 0 0 20px rgba(255, 215, 0, 1), 0 0 30px rgba(255, 215, 0, 0.8);
          }
          100% {
            box-shadow: 0 0 5px rgba(255, 215, 0, 0.7);
          }
        }

        .memory-card.glowing {
          animation: cardGlow 1s ease-in-out infinite;
          border: 2px solid rgba(255, 215, 0, 0.8);
        }

        .card-content {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          position: relative;
        }

        .card-image {
          max-width: 90%;
          max-height: 80%;
          object-fit: contain;
          border-radius: 8px;
        }

        .card-back-logo {
          max-width: 85%;
          max-height: 85%;
          object-fit: contain;
          opacity: 0.3;
          filter: grayscale(20%) brightness(1.1);
        }

        .card-text, .card-text-fallback {
          font-size: 1.2rem;
          font-weight: 600;
          text-align: center;
          color: #2c3e50;
          padding: 0.5rem;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }

        @media (max-width: 768px) {
          .card-image {
            max-height: 70%;
          }

          .card-text, .card-text-fallback {
            font-size: 1rem;
          }
        }
      `}</style>
    </>
  );
}

export default Card;
